import { unknownAuthStates } from 'constants';

export default function authStateKnown(userAuth) {
    if (Array.isArray(userAuth) && userAuth.length) {
        return userAuth.every(auth => unknownAuthStates.indexOf(auth) === -1)
    }
    return false;
};



// WEBPACK FOOTER //
// ./app/lib/auth/authStateKnown.js